import Model from "./model";

/* eslint-disable no-unused-expressions */
class MonitoringSetting extends Model {
  constructor(monitoringTargetId = null, monitoringSettingId = null) {
    super();
    this._monitoringTargetId = monitoringTargetId;
    this._monitoringSettingId = monitoringSettingId;

    this._monitoringSettingType;
    this._monitoringDeviceId;
    this._monitoringEventStatus;
    this._organizationId;
    this._projectId;
  }

  get monitoringTargetId() {
    return this._monitoringTargetId;
  }

  set monitoringTargetId(value) {
    this._monitoringTargetId = value;
  }

  get monitoringSettingId() {
    return this._monitoringSettingId;
  }

  set monitoringSettingId(value) {
    this._monitoringSettingId = value;
  }

  get monitoringSettingType() {
    return this._monitoringSettingType;
  }

  set monitoringSettingType(value) {
    this._monitoringSettingType = value;
  }

  get monitoringDeviceId() {
    return this._monitoringDeviceId;
  }

  set monitoringDeviceId(value) {
    this._monitoringDeviceId = value;
  }

  get monitoringEventStatus() {
    return this._monitoringEventStatus;
  }

  set monitoringEventStatus(value) {
    this._monitoringEventStatus = value;
  }

  get organizationId() {
    return this._organizationId;
  }

  set organizationId(value) {
    this._organizationId = value;
  }

  get projectId() {
    return this._projectId;
  }

  set projectId(value) {
    this._projectId = value;
  }

  json() {
    return {
      ...super.json(),
      monitoringTargetId: this.monitoringTargetId,
      monitoringSettingId: this.monitoringSettingId,
      monitoringSettingType: this.monitoringSettingType,
      monitoringDeviceId: this.monitoringDeviceId,
      // monitoringEventStatus: {},
      organizationId: this.organizationId,
      projectId: this.projectId,
    };
  }

  copy() {
    const monitoringSetting
      = new MonitoringSetting(this.monitoringTargetId, this.monitoringSettingId);
    monitoringSetting.copyProperties(this);
    return monitoringSetting;
  }

  copyProperties(monitoringSetting) {
    super.copyProperties(monitoringSetting);

    this.monitoringTargetId = monitoringSetting.monitoringTargetId;
    this.monitoringSettingId = monitoringSetting.monitoringSettingId;
    this.monitoringSettingType = monitoringSetting.monitoringSettingType;
    this.monitoringDeviceId = monitoringSetting.monitoringDeviceId;
    this.monitoringEventStatus = monitoringSetting.monitoringEventStatus;
    this.organizationId = monitoringSetting.organizationId;
    this.projectId = monitoringSetting.projectId;
  }

  getApiRequestJson() {
    const requestJosn = super.getApiRequestJson();

    Object.assign(requestJosn, {
      monitoring_target_id: this.monitoringTargetId,
      monitoring_setting_id: this.monitoringSettingId,
      monitoring_setting_type: this.monitoringSettingType,
      monitoring_device_id: this.monitoringDeviceId,
      organization_id: this.organizationId,
      project_id: this.projectId,
    });
    return requestJosn;
  }

  setApiResponseJosn(item) {
    super.setApiResponseJosn(item);
    this.monitoringTargetId = item.monitoring_target_id;
    this.monitoringSettingId = item.monitoring_setting_id;
    this.monitoringSettingType = item.monitoring_setting_type;
    this.monitoringDeviceId = item.monitoring_device_id;
    // this.monitoringEventStatus = {},
    this.organizationId = item.organization_id;
    this.projectId = item.project_id;
  }
}
/* eslint-enable */

export default MonitoringSetting;
